<div class="col-md-8">
  <label class="form-label">{{ title }}</label>
  <button
    class="form-control text-left image-input__button"
    (click)="imageFileInput.click()"
    yp-e2e-id="image-input-button"
  >
    {{ control.value?.filename || "Choose file" }}
    <span
      *ngIf="control.value?.filename"
      (click)="clearSelectedBackground($event)"
    ><i class="fa fa-times mx-2 red"></i
    ></span>
  </button>
  <input
    type="file"
    [accept]="extensionsString"
    #imageFileInput
    (change)="onImageSelected($event)"
  />
  <span *ngIf="subtitle" class="form-label image-subtitle">
    {{ subtitle }}
  </span>
  <div
    *ngIf="withPreview && (control?.value?.src || control?.value?.link)"
    class="img-preview mt-2 me-2"
  >
    <span>
      <i
        class="fa fa-times image-preview__close-btn"
        (click)="clearSelectedBackground($event)"
      ></i>
    </span>
    <img
      [src]="control.value.src ? control.value.src : control.value.link"
      alt="Preview"
      yp-e2e-id="background-preview"
    />
    <div class="image-preview__title">
      {{ control.value.filename }}
    </div>
  </div>
  <div
    class="alert-container"
    *ngIf="control.errors"
    yp-e2e-id="image-size-error"
  >
    <div class="alert alert-danger" *ngIf="control.errors?.fileMaxSize">
      {{ FIELD_BACKGROUND_IMAGE_SIZE_ERROR }}
    </div>
  </div>
  <div
    class="alert-container"
    *ngIf="control.errors"
    yp-e2e-id="error-image-ratio"
  >
    <div class="alert alert-danger" *ngIf="control.errors?.imageRatio">
      {{ control.errors.imageRatio }}
    </div>
  </div>
  <div
    class="alert-container"
    *ngIf="control.errors"
    yp-e2e-id="error-image-dimension"
  >
    <div class="alert alert-danger" *ngIf="control.errors?.imageDimensionInPx">
      {{ control.errors.imageDimensionInPx }}
    </div>
  </div>
</div>
